import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-unblock-user',
  templateUrl: './unblock-user.component.html',
  styleUrls: ['./unblock-user.component.css']
})
export class UnblockUserComponent implements OnInit {
  activeTab = "individuals"
  loading = false
  arrList
  totalItems
  objArr
  pageNo
  pageSize
  url = 'community/blockedUserList'
  unblockurl ='unblock/user'
  arr = [1, 2, 3, 4, 5]
  constructor(private authService: AuthservicesService) {
    this.pageSize = environment.pageSize
  }

  ngOnInit(): void {
    this.userList(1, this.url)
    // this.merchantsUnblocked(1);
  }



  userList(event, url) {
    this.pageNo = event
    let skip = this.authService.createSkip(this.pageNo, this.pageSize);
    this.authService.getUnblockedList(url, skip, this.pageSize).subscribe((res: any) => {
      this.loading = true
      this.arrList = res.items
      this.totalItems = res.total
      this.objArr = this.createArray(this.arrList)
    },
      error => {
        this.loading = true
        this.objArr = []
        console.log(error)
      })
  }



  unblockUsers(id) {
    
    let swall = this.authService.swal('unblock')

    swall.then((result) => {
      if (result.value == true) {
        this.authService.unblockUsers(this.unblockurl, id).subscribe((res: any) => {
          this.authService.successMessage(res.message, 'success')
          this.userList(this.pageNo,this.url)
        },
          error => {
            this.authService.successMessage(error.error.message, 'error')
          })
      }
    })
  }





  createArray(arr) {
    let obj = []
    arr.forEach((e) => {
      obj.push({
        id: (e._id) ? e._id : '',
        name: (e.name) ? e.name : '',
        email: (e.email) ? e.email : '',
        photo: (e.photo) ? this.renderImage(e.photo) : '',
        type: 'Blocked',
        reported: 'No',
        addStaff:''
      })
    })
    return obj;
  }

  getScrollTo(id: string) {
    this.activeTab = id
    this.loading = false;

    if (this.activeTab == 'fellowships') {
      this.url = 'blockCommunityList'
      this.unblockurl = 'unblock/community'
      this.userList(1, this.url)
    }

    if (this.activeTab == 'merchants') {
      this.url = 'getBlockedMerchants',
        this.unblockurl = 'unblock/merchant'

      this.userList(1, this.url)

    }
    if (this.activeTab == 'individuals') {
      this.url = 'community/blockedUserList'
      this.unblockurl = 'unblock/user'


      this.userList(1, this.url)
    }

    const element = this.getElementById(id)


  }

  getElementById(id: string): HTMLElement {
    const element = <HTMLElement>document.querySelector(`#${id}`);
    return element;
  }


  renderImage(data) {
    return this.authService.spilturl(data)
  }
}
